module.exports = __webpack_public_path__ + "img/sort.13ec46d4.svg";